import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import type { NavigationExtras } from './types';

export interface BcfRouterStateEnhancer {
  enhance(
    pathname: string,
    currentHistoryState: Record<string, any>,
    newState: Record<string, any>,
    extras: NavigationExtras | undefined
  ): Record<string, any>;
}

export class BcfRouterStateEnhancerRegistry {
  private _impls: Set<BcfRouterStateEnhancer> = new Set();

  public register(impl: BcfRouterStateEnhancer): void {
    this._impls.add(impl);
  }

  public unregister(impl: BcfRouterStateEnhancer): void {
    this._impls.delete(impl);
  }

  public enhance(
    pathname: string,
    currentHistoryState: Record<string, any>,
    newState: Record<string, any>,
    extras: NavigationExtras | undefined
  ): Record<string, any> {
    let state: Record<string, any> = newState;
    for (const impl of this._impls) {
      state = impl.enhance(pathname, currentHistoryState, state, extras);
    }
    return state;
  }
}

export function provideBcfRouterStateEnhancerRegistry(): BcfRouterStateEnhancerRegistry {
  return provideSingleton(BcfRouterStateEnhancerRegistry, () => new BcfRouterStateEnhancerRegistry());
}
